import { render, staticRenderFns } from "./PromoBanner.vue?vue&type=template&id=3a7858d6&"
import script from "./PromoBanner.vue?vue&type=script&lang=js&"
export * from "./PromoBanner.vue?vue&type=script&lang=js&"
import style0 from "./PromoBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports